import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import apiManager from '../../api/api-manager';
import { commonErrorMessages } from '../../messages';
import { GlobalActions } from '../../model';
import { appRoutes } from '../../routing';
import { ACTION_LOGOUT } from '../../store';
import { useAppDispatch } from '../redux';

export const useApiResponseInterceptorLogic = (
  globalActions: GlobalActions
) => {
  const { showToast, closeToast, navigate } = globalActions;
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const resInterceptor = (response) => response;

    const errInterceptor = (error) => {
      if (error?.response?.status === 401) {
        navigate(appRoutes.Login, { replace: true });
        dispatch({
          type: ACTION_LOGOUT,
        });
        showToast({
          type: 'error',
          title: formatMessage(commonErrorMessages.errorExpiredToken),
          close: closeToast,
        });
        return Promise.reject(error);
      }

      return Promise.reject(error);
    };

    const interceptor = apiManager.axiosInstance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () =>
      apiManager.axiosInstance.interceptors.response.eject(interceptor);
  }, [showToast, closeToast, navigate, dispatch, formatMessage]);
};
